import script from "./ContactPointPatientStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactPointPatientStrip.vue?vue&type=script&setup=true&lang=js"

import "./ContactPointPatientStrip.vue?vue&type=style&index=0&id=6fb72ba7&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb72ba7"]])

export default __exports__